export enum CardEventCategory {
    Lists = "my lists",
    SavedSearches = "my saved searches",
    CsvEnrichment = "CSV enrichment",
    CrmEnrichment = "CRM enrichment",
}

export enum SearchType {
    New = "new search",
    Recent = "recent",
}
